import { createResourceStore } from "@/lib/resource";

export interface UnitType {
  id: string;
  name: string;
  shop_id: string;
}

export const useUnitType = createResourceStore<UnitType>("unit-types");
